import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

const propTypes = {
    children: PropTypes.node,
};

const mapStateToProps = state => ({
    headerLogoPC: state.common.headerLogoPC,
    headerLogoMobile: state.common.headerLogoMobile,
    footerLeft: state.common.footerLeft,
    footerRight: state.common.footerRight,
});

const mapDispatchToProps = dispatch => ({
});

const defaultProps = {};

class DefaultFooter extends Component {
    render() {
        return (
            <React.Fragment>
                <span>{this.props.footerLeft}</span>
                <span className="ml-auto">{this.props.footerRight}</span>
            </React.Fragment>
        );
    }
}

DefaultFooter.propTypes = propTypes;
DefaultFooter.defaultProps = defaultProps;

export default (connect(mapStateToProps, mapDispatchToProps)(DefaultFooter));


// WEBPACK FOOTER //
// ./src/containers/Footer.js